import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import "../Car_info/Car_info.css";
import DateDent from "./Component/DateDent";
import NavbarDownConsumer from "../../commons/NavbarDownConsumer";

class car_info extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <Title
          text1="Tell us about your vehicle."
        />
        <DateDent />
        <NavbarDownConsumer />
      </React.Fragment>
    );
  }
}

export default car_info;
